import { render, staticRenderFns } from "./CopyStakeStats.vue?vue&type=template&id=1ae6bca0&lang=pug"
import script from "./CopyStakeStats.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStats.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeStats.vue?vue&type=style&index=0&id=1ae6bca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
